import { add_skills, intro } from '../../data';

import './style.css';

export default function AboutPage(params) {
  return (
    <div className="container aboutPage">
      <div className="body">
        <div className="h-full flex w-full items-center flex-col md:flex-row">
          <div className="px-4 w-full md:w-1/2">
            <div className="heading">
              <h1 className="text-secondary-300">My, Myself & I</h1>
            </div>
            <div className="paragraph">
              <p>{intro}</p>
              <p>{add_skills}</p>
            </div>
          </div>
          <div className="p-4 py-4 w-full md:w-1/2  ">
            <div className="paragraph">
              <div className="aboutDetails">
                <p>
                  Son of Mr. Anwar Mustfa and Mrs. Rowsan Ara Begum, both are
                  teacher.
                  <br className="pt-2" />
                  Well-organized person, problem solver, independent employee
                  with high attention to detail. Love in sports and traveling.
                  Fan of politics and debates. <br /> Interested in the entire
                  frontend spectrum and working on ambitious projects with
                  positive people.
                  <br />
                  <span className="my-4 text-secondary-400 text-sm md:text-lg">
                    Let’s make something special.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
